import * as React from "react"

function SvgComponent(props) {
  return (
    <svg
      data-name="swimming-pool (1)"
      xmlns="http://www.w3.org/2000/svg"
      width={154.362}
      height={154.362}
      viewBox="0 0 154.362 154.362"
      {...props}
    >
      <path
        data-name="Path 7874"
        d="M2.261 76.729h149.84v45.223H2.261z"
        fill="#2accf4"
      />
      <path
        data-name="Path 7875"
        d="M143.056 76.729h9.045v45.223h-9.045z"
        fill="#22b3eb"
      />
      <path
        data-name="Path 7876"
        d="M2.261 67.684h149.84v9.045H2.261z"
        fill="#8aeeff"
      />
      <path
        data-name="Path 7877"
        d="M143.056 67.684h9.045v9.045h-9.045z"
        fill="#63e5ff"
      />
      <path
        data-name="Path 7878"
        d="M35.878 120.595h-9.045V42.811a4.523 4.523 0 019.045 0z"
        fill="#f1f1f1"
      />
      <path
        data-name="Path 7879"
        d="M70.85 120.595h-9.045V42.811a4.523 4.523 0 119.045 0z"
        fill="#f1f1f1"
      />
      <path
        data-name="Path 7880"
        d="M152.101 104.164c-6.244 0-6.244 5.228-12.489 5.228s-6.244-5.228-12.489-5.228-6.244 5.228-12.487 5.228-6.244-5.228-12.487-5.228-6.243 5.228-12.487 5.228-6.242-5.228-12.485-5.228-6.242 5.228-12.485 5.228-6.243-5.228-12.486-5.228-6.243 5.228-12.487 5.228-6.243-5.228-12.487-5.228-6.243 5.228-12.486 5.228-6.242-5.228-12.485-5.228v31.053A16.883 16.883 0 0019.144 152.1h116.074a16.883 16.883 0 0016.883-16.883z"
        fill="#b9f5ff"
      />
      <g data-name="Group 382" fill="#8aeeff">
        <path
          data-name="Path 7881"
          d="M80.619 109.392a7.817 7.817 0 004.522-1.29c-2.374-1.548-3.742-3.938-7.964-3.938a7.816 7.816 0 00-4.522 1.29c2.373 1.548 3.742 3.938 7.964 3.938z"
        />
        <path
          data-name="Path 7882"
          d="M105.593 109.392a7.819 7.819 0 004.522-1.29c-2.374-1.548-3.742-3.938-7.965-3.938a7.817 7.817 0 00-4.522 1.29c2.374 1.548 3.742 3.938 7.965 3.938z"
        />
        <path
          data-name="Path 7883"
          d="M55.647 109.392a7.816 7.816 0 004.522-1.29c-2.373-1.548-3.742-3.938-7.964-3.938a7.817 7.817 0 00-4.522 1.29c2.374 1.548 3.741 3.938 7.964 3.938z"
        />
        <path
          data-name="Path 7884"
          d="M130.568 109.392a7.819 7.819 0 004.522-1.29c-2.375-1.548-3.743-3.939-7.966-3.939a7.817 7.817 0 00-4.522 1.29c2.374 1.549 3.745 3.939 7.966 3.939z"
        />
        <path
          data-name="Path 7885"
          d="M143.057 108.699v26.519a16.883 16.883 0 01-16.884 16.883h9.045a16.883 16.883 0 0016.883-16.883v-31.054c-4.82 0-5.921 3.114-9.044 4.535z"
        />
        <path
          data-name="Path 7886"
          d="M5.702 109.392a7.817 7.817 0 004.522-1.29c-2.373-1.548-3.741-3.938-7.963-3.938v4.536a8.093 8.093 0 003.441.692z"
        />
        <path
          data-name="Path 7887"
          d="M30.674 109.392a7.817 7.817 0 004.522-1.29c-2.374-1.548-3.742-3.938-7.964-3.938a7.817 7.817 0 00-4.522 1.29c2.373 1.548 3.742 3.938 7.964 3.938z"
        />
      </g>
      <g data-name="Group 383" fill="#d0d0d0">
        <path data-name="Path 7888" d="M35.877 46.58h25.928v9.045H35.877z" />
        <path data-name="Path 7889" d="M35.877 67.684h25.928v9.045H35.877z" />
        <path data-name="Path 7890" d="M35.877 88.788h25.928v9.045H35.877z" />
      </g>
      <circle
        data-name="Ellipse 392"
        cx={14.471}
        cy={14.471}
        r={14.471}
        transform="translate(105.521 12.964)"
        fill="#ffd54f"
      />
      <path
        data-name="Path 7891"
        d="M119.992 12.964a14.444 14.444 0 00-4.522.725 14.471 14.471 0 010 27.493 14.471 14.471 0 104.522-28.218z"
        fill="#ffc128"
      />
      <g data-name="Group 384">
        <path
          data-name="Path 7892"
          d="M152.1 65.428h-7.085a2.261 2.261 0 000 4.522h4.824v4.522H73.111V69.95h61.353a2.261 2.261 0 000-4.522H73.111V42.812a6.79 6.79 0 00-6.784-6.784 6.791 6.791 0 00-6.783 6.784v1.507H38.138v-1.507a6.79 6.79 0 00-6.783-6.784 6.791 6.791 0 00-6.784 6.784v5.416a2.261 2.261 0 104.522 0v-5.419a2.264 2.264 0 012.261-2.261 2.268 2.268 0 012.261 2.261v61.183a10.03 10.03 0 00-4.522-1.946V57.755a2.261 2.261 0 10-4.522 0v7.673H2.261A2.261 2.261 0 000 67.684v67.534a19.166 19.166 0 0019.145 19.145h116.073a19.166 19.166 0 0019.145-19.145V67.684a2.261 2.261 0 00-2.263-2.256zM64.066 42.812a2.264 2.264 0 012.261-2.261 2.268 2.268 0 012.261 2.261v62.962a5.738 5.738 0 01-3.9 1.358c-.221 0-.427-.01-.626-.026zm-4.522 31.656H38.138v-4.522h21.406zm0 4.522v7.538H38.138v-7.537zM38.138 91.05h21.406v4.522H38.138zm21.406-25.622H38.138v-7.537h21.406zm-21.406 34.666h21.406v4.653a10.574 10.574 0 00-7.338-2.845 10.894 10.894 0 00-7.7 3.142c-1.447 1.211-2.492 2.087-4.792 2.087a6.7 6.7 0 01-1.581-.173zm21.406-51.253v4.522H38.138v-4.522zM4.522 78.99h20.049v23.216a11.875 11.875 0 00-5.033 2.839c-1.446 1.211-2.492 2.086-4.791 2.086s-3.345-.875-4.791-2.086a11.6 11.6 0 00-5.433-2.924V78.99zm0-9.045h20.049v4.522H4.522zm145.318 65.273a14.639 14.639 0 01-14.622 14.622H19.145a14.639 14.639 0 01-14.623-14.622V106.81a9.26 9.26 0 012.53 1.7 10.994 10.994 0 0015.389 0c1.446-1.211 2.492-2.087 4.791-2.087s3.345.875 4.792 2.087a16.015 16.015 0 002.732 1.956l.109.058a10.181 10.181 0 004.854 1.128 10.892 10.892 0 007.695-3.141c1.447-1.211 2.492-2.087 4.792-2.087s3.345.875 4.792 2.087a12.946 12.946 0 004.06 2.547c.035.012.07.025.106.036a10.7 10.7 0 003.529.559 10.889 10.889 0 007.694-3.142c1.446-1.211 2.491-2.086 4.791-2.086s3.345.875 4.792 2.087a10.892 10.892 0 007.695 3.141 11.978 11.978 0 001.761-.125 2.261 2.261 0 10-.669-4.473 7.439 7.439 0 01-1.093.076c-2.3 0-3.345-.875-4.792-2.087a10.892 10.892 0 00-7.695-3.142 10.447 10.447 0 00-4.066.761V78.99h76.729v23.13a11.6 11.6 0 00-5.435 2.924c-1.447 1.211-2.492 2.087-4.792 2.087s-3.346-.875-4.792-2.087a11 11 0 00-15.391 0c-1.447 1.211-2.492 2.087-4.792 2.087s-3.345-.875-4.792-2.087a10.892 10.892 0 00-7.7-3.142 10.771 10.771 0 00-3.378.5 2.261 2.261 0 001.4 4.3 6.335 6.335 0 011.98-.283c2.3 0 3.345.875 4.792 2.087a11 11 0 0015.39 0c1.447-1.211 2.492-2.087 4.792-2.087s3.346.875 4.792 2.087a11 11 0 0015.392 0 9.251 9.251 0 012.531-1.7v28.412z"
        />
        <path
          data-name="Path 7893"
          d="M119.993 10.703a16.733 16.733 0 1016.733 16.733 16.752 16.752 0 00-16.733-16.733zm0 28.943a12.21 12.21 0 1112.21-12.21 12.224 12.224 0 01-12.21 12.21z"
        />
        <path
          data-name="Path 7894"
          d="M119.992 8.743a2.261 2.261 0 002.261-2.261V2.261a2.261 2.261 0 00-4.522 0v4.221a2.261 2.261 0 002.261 2.261z"
        />
        <path
          data-name="Path 7895"
          d="M117.882 48.087v4.221a2.261 2.261 0 104.522 0v-4.221a2.261 2.261 0 00-4.522 0z"
        />
        <path
          data-name="Path 7896"
          d="M107.633 10.399a2.261 2.261 0 003.916-2.261l-2.11-3.655a2.261 2.261 0 10-3.916 2.261z"
        />
        <path
          data-name="Path 7897"
          d="M129.394 43.267a2.261 2.261 0 00-.828 3.089l2.11 3.655a2.261 2.261 0 003.916-2.261l-2.11-3.655a2.261 2.261 0 00-3.088-.828z"
        />
        <path
          data-name="Path 7898"
          d="M97.191 16.731l3.655 2.11a2.261 2.261 0 002.261-3.916l-3.655-2.11a2.261 2.261 0 10-2.261 3.916z"
        />
        <path
          data-name="Path 7899"
          d="M136.953 39.514l3.655 2.11a2.261 2.261 0 102.261-3.916l-3.655-2.11a2.261 2.261 0 00-2.261 3.916z"
        />
        <path
          data-name="Path 7900"
          d="M94.969 29.546h4.221a2.261 2.261 0 100-4.522h-4.221a2.261 2.261 0 100 4.522z"
        />
        <path
          data-name="Path 7901"
          d="M138.534 27.134a2.261 2.261 0 002.261 2.261h4.221a2.261 2.261 0 000-4.522h-4.221a2.261 2.261 0 00-2.261 2.261z"
        />
        <path
          data-name="Path 7902"
          d="M100.846 35.725l-3.655 2.11a2.261 2.261 0 102.261 3.916l3.655-2.11a2.261 2.261 0 10-2.261-3.916z"
        />
        <path
          data-name="Path 7903"
          d="M137.936 19.015a2.253 2.253 0 001.129-.3l3.655-2.11a2.261 2.261 0 00-2.261-3.916l-3.655 2.11a2.261 2.261 0 001.133 4.22z"
        />
        <path
          data-name="Path 7904"
          d="M107.633 44.17l-2.11 3.655a2.261 2.261 0 103.916 2.261l2.11-3.655a2.261 2.261 0 00-3.916-2.261z"
        />
        <path
          data-name="Path 7905"
          d="M129.136 11.151a2.26 2.26 0 003.089-.828l2.11-3.655a2.262 2.262 0 00-3.92-2.26l-2.11 3.655a2.261 2.261 0 00.831 3.088z"
        />
        <path
          data-name="Path 7906"
          d="M36.179 119.54h-9.045a2.261 2.261 0 100 4.522h9.045a2.261 2.261 0 100-4.522z"
        />
        <path
          data-name="Path 7907"
          d="M127.228 132.806h-12.06a2.261 2.261 0 100 4.522h12.06a2.261 2.261 0 100-4.522z"
        />
        <path
          data-name="Path 7908"
          d="M101.3 124.063H75.975a2.261 2.261 0 100 4.522H101.3a2.261 2.261 0 000-4.522z"
        />
        <path
          data-name="Path 7909"
          d="M60.298 130.695H43.414a2.261 2.261 0 100 4.522h16.883a2.261 2.261 0 100-4.522z"
        />
      </g>
    </svg>
  )
}

const MemoSvgComponent = React.memo(SvgComponent)
export default MemoSvgComponent
